// This regex matches the built-in html 5 email address check.
// That is a is a willful violation of RFC 5322, which defines
// a syntax for e-mail addresses that is simultaneously too
// strict (before the "@" character), too vague (after the
// "@" character), and too lax (allowing comments,
// whitespace characters, and quoted strings in manners
// unfamiliar to most users) to be of practical use here.

export const isValidEmailAddress = (email = '')  => {
  const result = !!email.match(
      /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    ) &&
    email !== "" &&
    email !== undefined &&
    email !== null;
  return result;
};

export const isFieldValueNonEmpty = (value: any) => {
  const result = value !== null &&
    value !== undefined &&
    value !== ''
  return result;
}; // check for existence

// A Salesforce My Domain host, e.g. yourorg.my.salesforce.com or
// yourorg--sandbox.sandbox.my.salesforce.com, with or without
// https:// (any other scheme, a path or a port is rejected).
// login.salesforce.com, test.salesforce.com and instance hosts
// (e.g. na123.salesforce.com) do not end in .my.salesforce.com
// and so are rejected too. Mirrors the backoffice check.
const salesforceMyDomainPattern =
  /^(?:https:\/\/)?((?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+my\.salesforce\.com)\/?$/i;

export const isValidSalesforceMyDomain = (value: unknown) => {
  if (typeof value !== 'string') return false;
  return salesforceMyDomainPattern.test(value.trim());
};
